import { Button, Heading, Modal } from '@zillow/constellation-10';
import { ExitReason } from '../../../models';
import { useIdVerificationCallbacks } from '../../Idv/IdvContext';
import { wizardExitButtonStyles, wizardHeaderStyles } from './wizardShellStyles';

export default function Header({ titleId }: { titleId: string }) {
  const { onExit } = useIdVerificationCallbacks();

  return (
    <Modal.Header css={wizardHeaderStyles}>
      <Heading id={titleId} level={1}>
        Identity verification
      </Heading>
      <Button
        tone="neutral"
        emphasis="outlined"
        css={wizardExitButtonStyles}
        onClick={() =>
          onExit({
            reason: ExitReason.ModalClose,
            success: false,
          })
        }
      >
        Exit
      </Button>
    </Modal.Header>
  );
}
